import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const ar = {
  brand: { name: "أمان", tagline: "منصة التراخيص متعددة البرامج" },
  common: {
    add: "إضافة", create: "إنشاء", save: "حفظ", cancel: "إلغاء", close: "إغلاق", edit: "تعديل", delete: "حذف",
    search: "بحث", filter: "تصفية", refresh: "تحديث", loading: "جارٍ التحميل", retry: "إعادة المحاولة", actions: "الإجراءات",
    status: "الحالة", name: "الاسم", key: "المفتاح", type: "النوع", date: "التاريخ", amount: "المبلغ", currency: "العملة",
    active: "نشط", suspended: "معلّق", blocked: "محظور", enabled: "مفعّل", disabled: "معطّل", pending: "قيد الانتظار",
    approved: "تمت الموافقة", denied: "مرفوض", consumed: "مُستخدم", released: "تم فك الارتباط", replaced: "تم الاستبدال",
    revoked: "ملغي", expired: "منتهي", cancelled: "ملغي", completed: "مكتمل", failed: "فشل", running: "قيد التنفيذ", sent: "تم الإرسال", delivered: "تم التسليم",
    healthy: "سليم", unhealthy: "غير سليم", unknown: "غير معروف", all: "الكل", none: "لا يوجد", details: "التفاصيل",
    copied: "تم النسخ", download: "تنزيل", upload: "رفع", install: "تثبيت", yes: "نعم", no: "لا", email: "البريد الإلكتروني",
    password: "كلمة المرور", displayName: "الاسم الظاهر", username: "اسم المستخدم", phone: "الهاتف", reason: "السبب",
    required: "حقل مطلوب", noData: "لا توجد بيانات", noDataDescription: "لم يتم العثور على سجلات مطابقة.",
    showing: "عرض {{count}} سجل", previous: "السابق", next: "التالي", submit: "تنفيذ", back: "رجوع", preview: "معاينة",
    apiCode: "رمز الخطأ: {{code}}", requestId: "رقم الطلب: {{id}}", success: "تم تنفيذ العملية بنجاح", language: "English",
    theme: "المظهر", light: "فاتح", dark: "داكن", signOut: "تسجيل الخروج", account: "الحساب", open: "فتح", limit: "الحد",
    used: "المستخدم", available: "المتاح", balance: "الرصيد", reserved: "المحجوز", user: "المستخدم", plugin: "الإضافة",
    select: "اختر...", file: "الملف", progress: "التقدم", version: "الإصدار", description: "الوصف", scope: "الصلاحية"
  },
  auth: { title: "مرحبًا بعودتك", subtitle: "سجّل الدخول لإدارة التراخيص والإضافات بأمان", remember: "تذكرني على هذا الجهاز", signIn: "تسجيل الدخول", secure: "جلسة محمية بسياسات الوصول", sessionCheck: "جارٍ التحقق من الجلسة" },
  nav: {
    main: "الرئيسية", commerce: "التجارة", licensing: "التراخيص", platform: "المنصة", security: "الأمان", dashboard: "لوحة المعلومات",
    products: "المنتجات", plans: "الخطط", customers: "العملاء", resellers: "الموزعون", wallets: "المحافظ", orders: "الطلبات",
    payments: "المدفوعات", licenses: "التراخيص", devices: "الأجهزة", resources: "الموارد", credits: "الأرصدة", operations: "العمليات",
    operationPrices: "تسعير العمليات", artifacts: "الملفات", updates: "سياسات التحديث", plugins: "الإضافات", pluginBuilder: "منشئ الإضافات",
    pluginUsers: "مستخدمو الإضافات", audit: "سجل التدقيق", fraud: "مكافحة الاحتيال", notifications: "الإشعارات", settings: "الإعدادات",
    backups: "النسخ الاحتياطية", resellerPortal: "بوابة الموزع"
  },
  pages: {
    dashboard: { title: "لوحة المعلومات", subtitle: "نظرة مباشرة على صحة المنصة ونشاطها", products: "المنتجات", licenses: "التراخيص", resellers: "الموزعون", plugins: "الإضافات", platformHealth: "صحة المنصة", quickActions: "إجراءات سريعة", recentActivity: "أحدث النشاطات" },
    products: { title: "المنتجات", subtitle: "إدارة البرامج التي تمنحها المنصة تراخيص", add: "إضافة منتج" },
    plans: { title: "الخطط", subtitle: "تحديد مدة الترخيص وحدود الأجهزة والموارد", add: "إضافة خطة" },
    customers: { title: "العملاء", subtitle: "إدارة مالكي التراخيص وحساباتهم", add: "إضافة عميل" },
    resellers: { title: "الموزعون", subtitle: "إدارة الوصول إلى الإضافات وحدود الشحن والمستخدمين", add: "إضافة موزع", grants: "صلاحيات وحدود الإضافات", login: "إنشاء حساب دخول", maxUsers: "الحد الأقصى للمستخدمين", perTransaction: "حد العملية", dailyLimit: "الحد اليومي", canManageUsers: "إدارة المستخدمين", canTopup: "شحن الأرصدة", saveGrant: "حفظ المنح" },
    licenses: { title: "التراخيص", subtitle: "إصدار وتجديد وإلغاء ونقل تراخيص البرامج", issue: "إصدار ترخيص", issuedKey: "مفتاح الترخيص الجديد", copyKey: "نسخ المفتاح", renew: "تجديد", revoke: "إلغاء", transfer: "نقل", product: "المنتج", plan: "الخطة", customer: "العميل" },
    devices: { title: "الأجهزة", subtitle: "مراقبة عمليات التفعيل والتحكم في الأجهزة", revoke: "إلغاء الجهاز" },
    resources: { title: "الموارد", subtitle: "ربط الموارد القابلة للترخيص بالعملاء" },
    credits: { title: "الأرصدة", subtitle: "حسابات الأرصدة ودفتر الحركات", grant: "منح رصيد", adjust: "تسوية", reserve: "حجز", capture: "تحصيل", release: "تحرير" },
    wallets: { title: "المحافظ", subtitle: "المحافظ المالية والتحويلات المتوازنة", create: "إنشاء محفظة", deposit: "إيداع", adjust: "تسوية", transfer: "تحويل", destination: "المحفظة المستهدفة" },
    orders: { title: "الطلبات", subtitle: "متابعة طلبات الشراء وحالاتها" }, payments: { title: "المدفوعات", subtitle: "سجل التحصيل والمراجع المالية" },
    operations: { title: "العمليات", subtitle: "متابعة دورة العمليات المدفوعة وتسويتها", resolve: "تسوية", transition: "نقل الحالة" },
    operationPrices: { title: "تسعير العمليات", subtitle: "تحديد تكلفة العملية وسياسة التحصيل", add: "إضافة سعر" },
    artifacts: { title: "ملفات البرامج", subtitle: "إدارة ملفات البرامج وإصداراتها", create: "إنشاء ملف", uploadVersion: "رفع إصدار", versions: "الإصدارات", sha256: "SHA-256" },
    updates: { title: "سياسات التحديث", subtitle: "فرض الإصدارات والقنوات لكل منتج", add: "إضافة سياسة" },
    plugins: { title: "الإضافات", subtitle: "تثبيت وإدارة أنظمة البرامج المعزولة", uploadInstall: "رفع وتثبيت", selectedFile: "الملف المحدد", openUi: "فتح الواجهة", enable: "تفعيل", disable: "تعطيل", health: "فحص الصحة", logs: "السجلات", noFile: "اختر حزمة tar أو tar.gz أولًا", installProgress: "تقدم تثبيت الإضافة", requestedScopes: "الصلاحيات المطلوبة", grantedScopes: "الصلاحيات الممنوحة" },
    pluginBuilder: { title: "منشئ الإضافات", subtitle: "إنشاء عقد تكامل واضح لوكيل البناء الخارجي", config: "الإعداد", manifest: "معاينة Manifest", prompt: "تعليمات الوكيل", package: "حزمة البناء", next: "التالي", generate: "توليد الملفات", downloadTar: "تنزيل Build Kit (.tar.gz)", downloadZip: "تنزيل ZIP", copyPrompt: "نسخ تعليمات الوكيل", pluginId: "معرّف الإضافة", author: "المطور", coreMin: "أدنى إصدار للنظام", apiPort: "منفذ API", internet: "السماح بالإنترنت", adminUi: "واجهة إدارة" },
    pluginUsers: { title: "مستخدمو الإضافات", subtitle: "إدارة المستخدمين ومحافظهم ضمن حدود كل إضافة", choosePlugin: "اختر إضافة", create: "إنشاء مستخدم", setStatus: "تغيير الحالة", deposit: "شحن الرصيد", adjust: "تسوية", ledger: "دفتر الحركات", expiresAt: "تاريخ الانتهاء" },
    audit: { title: "سجل التدقيق", subtitle: "أثر غير قابل للتعديل لجميع الإجراءات الحساسة" },
    fraud: { title: "مكافحة الاحتيال", subtitle: "قواعد المراقبة والحوادث المكتشفة", rules: "القواعد", events: "الحوادث", toggle: "تغيير التفعيل" },
    notifications: { title: "الإشعارات", subtitle: "متابعة الرسائل وقنوات الإرسال" }, settings: { title: "الإعدادات", subtitle: "تهيئة سياسات المنصة العامة", save: "حفظ الإعدادات" },
    backups: { title: "النسخ الاحتياطية", subtitle: "إنشاء النسخ ومراجعة جاهزية الاستعادة", create: "إنشاء نسخة الآن" },
    account: { title: "الحساب", subtitle: "بيانات الجلسة وتغيير كلمة المرور", currentPassword: "كلمة المرور الحالية", newPassword: "كلمة المرور الجديدة", changePassword: "تغيير كلمة المرور" },
    resellerPortal: { title: "بوابة الموزع", subtitle: "إدارة المستخدمين والشحن للإضافات الممنوحة فقط", grantedPlugins: "الإضافات الممنوحة", users: "المستخدمون", createUser: "إضافة مستخدم", topup: "شحن", usage: "{{used}} من {{limit}}", unlimited: "غير محدود", selectPlugin: "اختر بطاقة إضافة لإدارة مستخدميها" },
    pluginUi: { title: "واجهة الإضافة", secure: "تعمل الواجهة داخل إطار معزول ولا تستلم جلسة الإدارة", loadFailed: "تعذر تشغيل واجهة الإضافة" }
  },
  errors: {
    title: "تعذر إكمال الطلب", generic: "حدث خطأ غير متوقع. حاول مرة أخرى أو استخدم رقم الطلب عند التواصل مع الدعم.",
    AUTH_INVALID_CREDENTIALS: "بيانات الدخول غير صحيحة.", AUTH_ACCOUNT_LOCKED: "الحساب مقفل مؤقتًا.", AUTH_SESSION_REQUIRED: "يلزم تسجيل الدخول للمتابعة.", AUTH_SESSION_EXPIRED: "انتهت الجلسة؛ سجّل الدخول مجددًا.", AUTH_CSRF_INVALID: "تعذر التحقق من حماية الطلب.", AUTH_PERMISSION_DENIED: "ليست لديك صلاحية تنفيذ هذا الإجراء.",
    VALIDATION_FAILED: "تحقق من الحقول المدخلة.", RESOURCE_NOT_FOUND: "السجل المطلوب غير موجود.", RESOURCE_CONFLICT: "يتعارض الطلب مع سجل موجود.", IDEMPOTENCY_KEY_REQUIRED: "يلزم مفتاح لمنع التكرار.", IDEMPOTENCY_KEY_REUSED: "استُخدم مفتاح العملية مع طلب مختلف.", RATE_LIMITED: "طلبات كثيرة؛ انتظر قليلًا ثم أعد المحاولة.",
    PLUGIN_NOT_FOUND: "الإضافة غير موجودة.", PLUGIN_NOT_ENABLED: "الإضافة غير مفعلة.", PLUGIN_SCOPE_DENIED: "لم تُمنح الإضافة الصلاحية المطلوبة.", PLUGIN_MANIFEST_INVALID: "ملف تعريف الإضافة غير صالح.", PLUGIN_COMPATIBILITY_FAILED: "الإضافة غير متوافقة مع هذا الإصدار.", PLUGIN_BUNDLE_INVALID: "حزمة الإضافة غير صالحة.", PLUGIN_HEALTH_FAILED: "فشل فحص صحة الإضافة.",
    RESELLER_GRANT_REQUIRED: "الموزع غير مخول لهذه الإضافة.", RESELLER_GRANT_INACTIVE: "منحة الإضافة للموزع غير نشطة.", RESELLER_MAX_USERS_EXCEEDED: "تم بلوغ الحد الأقصى للمستخدمين.", RESELLER_TOPUP_LIMIT_EXCEEDED: "المبلغ يتجاوز حد العملية.", RESELLER_DAILY_LIMIT_EXCEEDED: "تم بلوغ حد الشحن اليومي.",
    WALLET_NOT_FOUND: "المحفظة غير موجودة.", WALLET_INACTIVE: "المحفظة غير نشطة.", WALLET_INSUFFICIENT_AVAILABLE: "الرصيد المتاح غير كافٍ.", WALLET_RESERVATION_NOT_FOUND: "عملية الحجز غير موجودة.", LICENSE_INVALID: "الترخيص غير صالح.", LICENSE_EXPIRED: "انتهى الترخيص.", LICENSE_REVOKED: "أُلغي الترخيص.",
    DEVICE_SIGNATURE_INVALID: "توقيع الجهاز غير صالح.", DEVICE_NONCE_REPLAYED: "رُفض طلب جهاز مكرر.", DEVICE_TIMESTAMP_INVALID: "توقيت الجهاز خارج النطاق المسموح.", OPERATION_TRANSITION_INVALID: "لا يمكن نقل العملية إلى الحالة المطلوبة.", INTERNAL_ERROR: "حدث خطأ داخلي.", SERVICE_UNAVAILABLE: "الخدمة غير متاحة حاليًا."
  }
};

const en = {
  brand: { name: "Aman", tagline: "Multi-program licensing platform" },
  common: { add: "Add", create: "Create", save: "Save", cancel: "Cancel", close: "Close", edit: "Edit", delete: "Delete", search: "Search", filter: "Filter", refresh: "Refresh", loading: "Loading", retry: "Retry", actions: "Actions", status: "Status", name: "Name", key: "Key", type: "Type", date: "Date", amount: "Amount", currency: "Currency", active: "Active", suspended: "Suspended", blocked: "Blocked", enabled: "Enabled", disabled: "Disabled", pending: "Pending", approved: "Approved", denied: "Denied", consumed: "Consumed", released: "Released", replaced: "Replaced", revoked: "Revoked", expired: "Expired", cancelled: "Cancelled", completed: "Completed", failed: "Failed", running: "Running", sent: "Sent", delivered: "Delivered", healthy: "Healthy", unhealthy: "Unhealthy", unknown: "Unknown", all: "All", none: "None", details: "Details", copied: "Copied", download: "Download", upload: "Upload", install: "Install", yes: "Yes", no: "No", email: "Email", password: "Password", displayName: "Display name", username: "Username", phone: "Phone", reason: "Reason", required: "Required field", noData: "No data", noDataDescription: "No matching records were found.", showing: "Showing {{count}} records", previous: "Previous", next: "Next", submit: "Submit", back: "Back", preview: "Preview", apiCode: "Error code: {{code}}", requestId: "Request ID: {{id}}", success: "Operation completed successfully", language: "العربية", theme: "Theme", light: "Light", dark: "Dark", signOut: "Sign out", account: "Account", open: "Open", limit: "Limit", used: "Used", available: "Available", balance: "Balance", reserved: "Reserved", user: "User", plugin: "Plugin", select: "Select...", file: "File", progress: "Progress", version: "Version", description: "Description", scope: "Scope" },
  auth: { title: "Welcome back", subtitle: "Sign in to securely manage licenses and plugins", remember: "Remember me", signIn: "Sign in", secure: "Session protected by access policies", sessionCheck: "Checking your session" },
  nav: { main: "Main", commerce: "Commerce", licensing: "Licensing", platform: "Platform", security: "Security", dashboard: "Dashboard", products: "Products", plans: "Plans", customers: "Customers", resellers: "Resellers", wallets: "Wallets", orders: "Orders", payments: "Payments", licenses: "Licenses", devices: "Devices", resources: "Resources", credits: "Credits", operations: "Operations", operationPrices: "Operation pricing", artifacts: "Artifacts", updates: "Update policies", plugins: "Plugins", pluginBuilder: "Plugin builder", pluginUsers: "Plugin users", audit: "Audit log", fraud: "Fraud", notifications: "Notifications", settings: "Settings", backups: "Backups", resellerPortal: "Reseller portal" },
  pages: {
    dashboard: { title: "Dashboard", subtitle: "Live view of platform health and activity", products: "Products", licenses: "Licenses", resellers: "Resellers", plugins: "Plugins", platformHealth: "Platform health", quickActions: "Quick actions", recentActivity: "Recent activity" }, products: { title: "Products", subtitle: "Manage licensed programs", add: "Add product" }, plans: { title: "Plans", subtitle: "Define licensing limits", add: "Add plan" }, customers: { title: "Customers", subtitle: "Manage license owners", add: "Add customer" },
    resellers: { title: "Resellers", subtitle: "Manage plugin access and limits", add: "Add reseller", grants: "Plugin grants and limits", login: "Create reseller login", maxUsers: "Maximum users", perTransaction: "Per-transaction cap", dailyLimit: "Daily cap", canManageUsers: "Manage users", canTopup: "Top up balances", saveGrant: "Save grant" }, licenses: { title: "Licenses", subtitle: "Issue and manage licenses", issue: "Issue license", issuedKey: "New license key", copyKey: "Copy key", renew: "Renew", revoke: "Revoke", transfer: "Transfer", product: "Product", plan: "Plan", customer: "Customer" }, devices: { title: "Devices", subtitle: "Monitor activations", revoke: "Revoke device" }, resources: { title: "Resources", subtitle: "Manage licensable resources" }, credits: { title: "Credits", subtitle: "Credit accounts and ledger", grant: "Grant", adjust: "Adjust", reserve: "Reserve", capture: "Capture", release: "Release" }, wallets: { title: "Wallets", subtitle: "Balanced financial wallets", create: "Create wallet", deposit: "Deposit", adjust: "Adjust", transfer: "Transfer", destination: "Destination wallet" },
    orders: { title: "Orders", subtitle: "Track purchase orders" }, payments: { title: "Payments", subtitle: "Track collection records" }, operations: { title: "Operations", subtitle: "Track paid operations", resolve: "Resolve", transition: "Transition" }, operationPrices: { title: "Operation pricing", subtitle: "Set operation costs", add: "Add price" }, artifacts: { title: "Artifacts", subtitle: "Manage files and versions", create: "Create artifact", uploadVersion: "Upload version", versions: "Versions", sha256: "SHA-256" }, updates: { title: "Update policies", subtitle: "Enforce versions and channels", add: "Add policy" },
    plugins: { title: "Plugins", subtitle: "Install isolated program systems", uploadInstall: "Upload & install", selectedFile: "Selected file", openUi: "Open UI", enable: "Enable", disable: "Disable", health: "Health check", logs: "Logs", noFile: "Choose a bundle first", installProgress: "Install progress", requestedScopes: "Requested scopes", grantedScopes: "Granted scopes" }, pluginBuilder: { title: "Plugin builder", subtitle: "Create an integration contract", config: "Configuration", manifest: "Manifest preview", prompt: "Agent instructions", package: "Build package", next: "Next", generate: "Generate files", downloadTar: "Download build kit (.tar.gz)", downloadZip: "Download ZIP", copyPrompt: "Copy agent prompt", pluginId: "Plugin ID", author: "Author", coreMin: "Minimum Core version", apiPort: "API port", internet: "Allow internet", adminUi: "Admin UI" }, pluginUsers: { title: "Plugin users", subtitle: "Manage tenant users and wallets", choosePlugin: "Choose plugin", create: "Create user", setStatus: "Set status", deposit: "Top up", adjust: "Adjust", ledger: "Ledger", expiresAt: "Expires at" },
    audit: { title: "Audit log", subtitle: "Immutable trail for sensitive actions" }, fraud: { title: "Fraud prevention", subtitle: "Rules and detected events", rules: "Rules", events: "Events", toggle: "Toggle" }, notifications: { title: "Notifications", subtitle: "Track delivery" }, settings: { title: "Settings", subtitle: "Configure platform policies", save: "Save settings" }, backups: { title: "Backups", subtitle: "Create and review backups", create: "Create backup" }, account: { title: "Account", subtitle: "Session and password", currentPassword: "Current password", newPassword: "New password", changePassword: "Change password" }, resellerPortal: { title: "Reseller portal", subtitle: "Manage users and top-ups for granted plugins", grantedPlugins: "Granted plugins", users: "Users", createUser: "Add user", topup: "Top up", usage: "{{used}} of {{limit}}", unlimited: "Unlimited", selectPlugin: "Select a plugin card" }, pluginUi: { title: "Plugin UI", secure: "Runs in an isolated frame without the admin session", loadFailed: "Could not load plugin UI" }
  },
  errors: Object.fromEntries(Object.keys(ar.errors).map((key) => [key, key === "title" ? "Request could not be completed" : key === "generic" ? "An unexpected error occurred." : "The request could not be completed."]))
};

Object.assign(ar.common, {
  installed: "مثبت", failed: "فاشل", cancelled: "ملغي", superseded: "مستبدل",
  succeeded: "ناجح", not_required: "غير مطلوب"
});
Object.assign(ar.pages.plugins, {
  currentVersion: "الإصدار الحالي", pendingVersion: "الإصدار المعلق", versionHistory: "سجل الإصدارات",
  migrations: "الترحيلات", activatePending: "تفعيل الإصدار المعلق", cancelPending: "إلغاء الإصدار المعلق",
  cancelPendingConfirm: "هل تريد إلغاء الإصدار المعلق؟ سيبقى الإصدار الحالي فعالًا.",
  inspectBundle: "فحص ملف الإضافة", inspecting: "جارٍ رفع الملف وفحصه…", inspectionPassed: "اجتاز الملف الفحص",
  inspectionFailed: "الملف غير قابل للتثبيت", errors: "الأخطاء", warnings: "التحذيرات",
  warningReason: "سبب متابعة التثبيت رغم التحذيرات", warningReasonHint: "للمدير الأعلى فقط، ويُحفظ السبب في سجل التدقيق.",
  warningReasonRequired: "اكتب سببًا واضحًا من 10 أحرف على الأقل لتجاوز التحذيرات.", installApproved: "إنشاء نسخة ثم التثبيت",
  preparingBackup: "جارٍ تجهيز النسخة الاحتياطية التلقائية قبل التثبيت…",
  backupPreparing: "تم جدولة النسخة الاحتياطية {{id}}، وسيستأنف التثبيت تلقائيًا عند اكتمالها.",
  backupStatus: "حالة النسخة الاحتياطية: {{status}}", installing: "اكتملت النسخة؛ جارٍ تثبيت الإضافة…",
  archive: "أرشفة الإضافة", archiveReason: "سبب الأرشفة", archiveConfirm: "هل تريد أرشفة الإضافة وإيقاف خدمتها؟ ستبقى بيانات العملاء والتراخيص والسجلات محفوظة.",
  archivedPreserved: "الإضافة مؤرشفة؛ لم تُحذف بيانات العملاء أو التراخيص أو الدفاتر التاريخية.",
  safetyBackup: "نسخة الأمان", rollback: "التراجع عن التثبيت/الترقية", rollbackReason: "سبب التراجع",
  rollbackConfirmation: "عبارة تأكيد التراجع", rollbackConfirmationHint: "اكتب العبارة حرفيًا: {{value}}",
  rollbackWarning: "يعيد هذا الإجراء النسخة الكاملة التي سبقت الإصدار الحالي؛ لذلك ستعود المنصة كلها إلى تلك اللحظة وتُفقد التغييرات الأحدث."
});
Object.assign(en.common, {
  installed: "Installed", failed: "Failed", cancelled: "Cancelled", superseded: "Superseded",
  succeeded: "Succeeded", not_required: "Not required"
});
Object.assign(en.pages.plugins, {
  currentVersion: "Current version", pendingVersion: "Pending version", versionHistory: "Version history",
  migrations: "Migrations", activatePending: "Activate pending version", cancelPending: "Cancel pending version",
  cancelPendingConfirm: "Cancel the pending version? The current version will remain active.",
  inspectBundle: "Inspect plugin bundle", inspecting: "Uploading and inspecting the bundle…", inspectionPassed: "Bundle passed inspection",
  inspectionFailed: "Bundle cannot be installed", errors: "Errors", warnings: "Warnings",
  warningReason: "Reason for continuing despite warnings", warningReasonHint: "Super administrators only; the reason is recorded in the audit log.",
  warningReasonRequired: "Enter a clear reason of at least 10 characters to override warnings.", installApproved: "Back up and install",
  preparingBackup: "Preparing the automatic pre-install backup…",
  backupPreparing: "Backup {{id}} was queued; installation will resume automatically when it completes.",
  backupStatus: "Backup status: {{status}}", installing: "Backup completed; installing the plugin…",
  archive: "Archive plugin", archiveReason: "Archive reason", archiveConfirm: "Archive the plugin and stop its service? Customer, license, and ledger records will be preserved.",
  archivedPreserved: "The plugin is archived; customer, license, and historical ledger records were preserved.",
  safetyBackup: "Safety backup", rollback: "Undo install/upgrade", rollbackReason: "Rollback reason",
  rollbackConfirmation: "Rollback confirmation", rollbackConfirmationHint: "Type this exactly: {{value}}",
  rollbackWarning: "This restores the full backup taken before the current version, so the entire platform returns to that point and newer changes are discarded."
});
Object.assign(ar.pages.devices, {
  release: "فك ارتباط الجهاز",
  token: "إنشاء رمز نقل",
  transferToken: "رمز نقل الجهاز",
  tokenOnce: "انسخ هذا الرمز أحادي الاستخدام الآن وأدخله في البرنامج على الجهاز الجديد.",
  transferRequests: "طلبات نقل الأجهزة",
  approve: "موافقة",
  deny: "رفض",
  identityVersion: "إصدار البصمة"
});
Object.assign(en.pages.devices, {
  release: "Release device",
  token: "Create transfer token",
  transferToken: "Device transfer token",
  tokenOnce: "Copy this one-time token now and enter it in the product on the new device.",
  transferRequests: "Device transfer requests",
  approve: "Approve",
  deny: "Deny",
  identityVersion: "Identity version"
});
Object.assign(ar.pages.products, {
  keyHint: "حروف إنجليزية صغيرة وأرقام وشرطة فقط، مثل video-suite",
  offlineLeaseHours: "مدة العمل دون اتصال (بالساعات)"
});
Object.assign(en.pages.products, {
  keyHint: "Lowercase letters, numbers, and hyphens only, for example video-suite",
  offlineLeaseHours: "Offline lease (hours)"
});
Object.assign(ar.pages.plans, {
  keyHint: "معرّف تقني ثابت للخطة بحروف إنجليزية صغيرة، مثل annual-pro. لا يُعرض للعميل كمفتاح ترخيص.",
  nameExample: "مثال: الاحترافية السنوية",
  noProducts: "أنشئ منتجًا أولًا قبل إضافة الخطة.",
  durationDays: "المدة بالأيام",
  durationHint: "اتركها فارغة للترخيص الدائم أو المبني على الاستخدام.",
  maxDevices: "الحد الأقصى للأجهزة",
  subscription: "اشتراك",
  perpetual: "دائم",
  trial: "تجريبي",
  usage: "حسب الاستخدام"
});
Object.assign(en.pages.plans, {
  keyHint: "A stable technical identifier using lowercase letters, such as annual-pro. This is not the customer's license key.",
  nameExample: "Example: Annual Professional",
  noProducts: "Create a product before adding a plan.",
  durationDays: "Duration (days)",
  durationHint: "Leave empty for perpetual or usage-based licenses.",
  maxDevices: "Maximum devices",
  subscription: "Subscription",
  perpetual: "Perpetual",
  trial: "Trial",
  usage: "Usage-based"
});
Object.assign(ar.pages.operationPrices, {
  operationType: "نوع العملية",
  operationTypeHint: "معرّف تقني ترسله الإضافة عند تنفيذ العملية، مثل firmware.flash",
  autoCapture: "التحصيل التلقائي",
  requiresEvidence: "يتطلب دليل تنفيذ"
});
Object.assign(en.pages.operationPrices, {
  operationType: "Operation type",
  operationTypeHint: "Technical identifier sent by the plugin, for example firmware.flash",
  autoCapture: "Auto capture",
  requiresEvidence: "Requires evidence"
});
Object.assign(ar.pages.pluginBuilder, {
  validationTitle: "بيانات الإضافة غير مكتملة",
  validationMessage: "أدخل معرفًا صحيحًا، واسمًا واسم المطور، ووصفًا لا يقل عن 10 أحرف، وتحقق من أرقام الإصدارات والمنفذ.",
});
Object.assign(en.pages.pluginBuilder, {
  validationTitle: "Plugin details are incomplete",
  validationMessage: "Enter a valid ID, name, author, a description of at least 10 characters, and verify the versions and port.",
});

Object.assign(ar.auth, { identifier: "البريد الإلكتروني أو رقم الهاتف" });
Object.assign(en.auth, { identifier: "Email or phone number" });
Object.assign(ar.nav, { customerPortal: "بوابة العميل" });
Object.assign(en.nav, { customerPortal: "Customer portal" });
Object.assign(ar.pages.resellerPortal, {
  subtitle: "إدارة العملاء والتراخيص والأرصدة من مكان واحد",
  credits: "كريدت",
  reserved: "المحجوز: {{amount}}",
  earnings: "أرباح العمولة",
  availableProducts: "منتجات متاحة لك",
  findCustomer: "البحث عن عميل",
  exactSearchOnly: "حفاظًا على الخصوصية، ابحث بالمعرف الكامل أو رقم الهاتف الدولي فقط.",
  searchPlaceholder: "cus_... أو +966...",
  customerNotFound: "لم يتم العثور على عميل مطابق.",
  addService: "إضافة خدمة",
  customerServices: "خدمات العميل وتراخيصه",
  expiresAt: "تاريخ الانتهاء",
  topup: "شحن رصيد العميل",
  topupComplete: "تم تحويل الكريدت إلى محفظة العميل.",
  productsAndPlans: "المنتجات والباقات المتاحة",
  commissions: "سجل العمولات",
  listPrice: "السعر الأساسي",
  paid: "المخصوم منك",
  profit: "الربح",
  displayPrice: "السعر المعروض",
  yourPrice: "تكلفتك",
  keyOnce: "يظهر مفتاح الترخيص مرة واحدة فقط؛ انسخه وسلّمه للعميل بأمان.",
  phoneHint: "استخدم الصيغة الدولية مثل +9665xxxxxxxx.",
  optionalLogin: "اختياري: أدخل كلمة مرور من 12 حرفًا لإنشاء دخول للعميل.",
  checkoutSummary: "السعر {{list}} كريدت — سيخصم {{charged}} — ربحك {{profit}} كريدت.",
  activateLicense: "تفعيل الترخيص",
  renewed: "تم التجديد وخصم {{amount}} كريدت. الانتهاء الجديد: {{expiry}}",
  approvedByReseller: "تمت الموافقة بواسطة الموزع",
  deniedByReseller: "تم رفض الطلب بواسطة الموزع",
  transferApproved: "تمت الموافقة. انسخ رمز النقل الظاهر واستخدمه في البرنامج على الجهاز الجديد.",
  transferDenied: "تم رفض طلب نقل الجهاز."
});
Object.assign(en.pages.resellerPortal, {
  subtitle: "Manage customers, licenses, and credit balances in one place",
  credits: "credits",
  reserved: "Reserved: {{amount}}",
  earnings: "Commission earnings",
  availableProducts: "products available to you",
  findCustomer: "Find a customer",
  exactSearchOnly: "For privacy, search only by the complete customer ID or international phone number.",
  searchPlaceholder: "cus_... or +966...",
  customerNotFound: "No matching customer was found.",
  addService: "Add service",
  customerServices: "Customer services and licenses",
  expiresAt: "Expires at",
  topup: "Top up customer",
  topupComplete: "Credits were transferred to the customer wallet.",
  productsAndPlans: "Available products and plans",
  commissions: "Commission history",
  listPrice: "List price",
  paid: "Deducted",
  profit: "Profit",
  displayPrice: "Displayed price",
  yourPrice: "Your cost",
  keyOnce: "The license key is shown once. Copy it and deliver it securely to the customer.",
  phoneHint: "Use international format, for example +9665xxxxxxxx.",
  optionalLogin: "Optional: enter a 12-character password to create customer portal access.",
  checkoutSummary: "List {{list}} credits — deduct {{charged}} — profit {{profit}} credits.",
  activateLicense: "Activate license",
  renewed: "Renewed for {{amount}} credits. New expiry: {{expiry}}",
  approvedByReseller: "Approved by reseller",
  deniedByReseller: "Denied by reseller",
  transferApproved: "Approved. Copy the transfer token and use it in the product on the new device.",
  transferDenied: "The device transfer request was denied."
});
Object.assign(ar.pages.resellers, {
  subtitle: "إدارة مستويات الموزعين وعمولاتهم والمنتجات المتاحة لهم",
  level: "مستوى الموزع",
  commission: "العمولة",
  assignLevel: "تعيين المستوى",
  catalogAccess: "المنتجات والباقات المتاحة",
  pluginGrant: "منحة إضافة قديمة",
  legacyPluginGrants: "صلاحيات الإضافات القديمة",
  commissionOverride: "عمولة مخصصة (%)",
  levelDefaultHint: "اتركها فارغة لاستخدام عمولة المستوى.",
  allPlansHint: "اترك الخطة فارغة لإتاحة جميع باقات المنتج.",
  parentId: "معرف الموزع الأب"
});
Object.assign(en.pages.resellers, {
  subtitle: "Manage reseller levels, commissions, and available products",
  level: "Reseller level",
  commission: "Commission",
  assignLevel: "Assign level",
  catalogAccess: "Available products and plans",
  pluginGrant: "Legacy plugin grant",
  legacyPluginGrants: "Legacy plugin permissions",
  commissionOverride: "Commission override (%)",
  levelDefaultHint: "Leave empty to use the reseller level commission.",
  allPlansHint: "Leave the plan empty to make every product plan available.",
  parentId: "Parent reseller ID"
});
Object.assign(ar.pages.customers, {
  phoneHint: "رقم دولي مثل +9665xxxxxxxx، ولا يمكن تكراره.",
  passwordHint: "اختياري: 12 حرفًا على الأقل لإنشاء دخول لبوابة العميل."
});
Object.assign(en.pages.customers, {
  phoneHint: "International format such as +9665xxxxxxxx; duplicates are not allowed.",
  passwordHint: "Optional: at least 12 characters to create customer portal access."
});
Object.assign(ar.pages, {
  customerPortal: {
    title: "بوابة العميل",
    subtitle: "متابعة التراخيص والأجهزة والرصيد",
    credits: "كريدت",
    reserved: "المحجوز: {{amount}}",
    activeDevices: "{{count}} جهاز نشط",
    myLicenses: "تراخيصي",
    renewed: "تم التجديد وخصم {{amount}} كريدت. الانتهاء الجديد: {{expiry}}",
    expiresAt: "تاريخ الانتهاء",
    devices: "الأجهزة",
    lastSeen: "آخر اتصال",
    walletHistory: "حركات المحفظة",
    transferPending: "تجاوزت حد النقل الذاتي؛ أُرسل الطلب للموزع أو المدير للموافقة.",
    deviceReleased: "تم فك ارتباط الجهاز ويمكن تفعيل جهاز جديد.",
    releaseWarning: "يُحتسب هذا ضمن عدد مرات النقل المسموح بها. إعادة تثبيت النظام على نفس الجهاز لا تُحتسب نقلًا."
  }
});
Object.assign(en.pages, {
  customerPortal: {
    title: "Customer portal",
    subtitle: "Track licenses, devices, and credit balance",
    credits: "credits",
    reserved: "Reserved: {{amount}}",
    activeDevices: "{{count}} active devices",
    myLicenses: "My licenses",
    renewed: "Renewed for {{amount}} credits. New expiry: {{expiry}}",
    expiresAt: "Expires at",
    devices: "Devices",
    lastSeen: "Last seen",
    walletHistory: "Wallet history",
    transferPending: "The self-transfer limit was reached; approval was requested from the reseller or administrator.",
    deviceReleased: "The device was released and a new device can be activated.",
    releaseWarning: "This counts toward the transfer allowance. Reinstalling the OS on the same hardware does not count as a transfer."
  }
});

Object.assign(ar.nav, { vouchers: "كروت الشحن" });
Object.assign(en.nav, { vouchers: "Credit vouchers" });
Object.assign(ar.pages, {
  vouchers: {
    title: "كروت الشحن", subtitle: "إنشاء فئات ودفعات كروت رقمية وشحن الكريدت بأمان",
    denominations: "فئات الشحن", denomination: "فئة الشحن", addDenomination: "إضافة فئة",
    denominationCreated: "تم إنشاء فئة الشحن.", credits: "كريدت", batches: "دفعات الكروت",
    createBatch: "إنشاء دفعة", batchCreated: "تم إنشاء الدفعة وبدأ تنزيل ملف PDF.",
    quantity: "عدد الكروت", quantityHint: "من 1 إلى 10000 كرت في الدفعة.", generate: "توليد الكروت",
    used: "المستخدم", downloadPdf: "تنزيل PDF", pdfDescription: "يحتوي الملف على كرت واحد من 12 رقمًا في كل سطر.",
    disable: "تعطيل", enable: "تفعيل", redeemTitle: "شحن الرصيد بكرت", redeemDescription: "أدخل رقم الكرت المكوّن من 12 رقمًا.",
    code: "رقم كرت الشحن", codeHint: "ثلاث محاولات خاطئة فقط يوميًا.", redeem: "شحن الرصيد",
    redeemed: "تمت إضافة {{credits}} كريدت. رصيدك الحالي {{balance}} كريدت."
  }
});
Object.assign(en.pages, {
  vouchers: {
    title: "Credit vouchers", subtitle: "Create voucher denominations and batches and redeem credits securely",
    denominations: "Voucher denominations", denomination: "Denomination", addDenomination: "Add denomination",
    denominationCreated: "Voucher denomination created.", credits: "credits", batches: "Voucher batches",
    createBatch: "Create batch", batchCreated: "The batch was created and its PDF download started.",
    quantity: "Voucher count", quantityHint: "Between 1 and 10,000 vouchers per batch.", generate: "Generate vouchers",
    used: "Used", downloadPdf: "Download PDF", pdfDescription: "The file contains one 12-digit voucher per line.",
    disable: "Disable", enable: "Enable", redeemTitle: "Redeem a voucher", redeemDescription: "Enter the 12-digit voucher number.",
    code: "Voucher number", codeHint: "Only three invalid attempts are allowed each day.", redeem: "Redeem",
    redeemed: "{{credits}} credits were added. Your current balance is {{balance}} credits."
  }
});
Object.assign(ar.errors, {
  VOUCHER_INVALID: "رقم كرت الشحن غير صحيح أو معطّل أو مستخدم سابقًا.",
  VOUCHER_ATTEMPTS_LOCKED: "تم بلوغ حد المحاولات الخاطئة. حاول مجددًا بعد بداية اليوم التالي بتوقيت الرياض."
});
Object.assign(en.errors, {
  VOUCHER_INVALID: "The voucher is invalid, disabled, or already used.",
  VOUCHER_ATTEMPTS_LOCKED: "The invalid-attempt limit was reached. Try again after the next Riyadh day begins."
});
Object.assign(ar.common, { pruned: "حُذفت وفق سياسة الاحتفاظ", running: "جارٍ التنفيذ" });
Object.assign(en.common, { pruned: "Pruned by retention policy", running: "Running" });
Object.assign(ar.pages.backups, {
  subtitle: "إنشاء وتنزيل نسخ شاملة من قواعد البيانات والملفات دون استخدام الطرفية",
  queued: "أُضيفت مهمة النسخ الاحتياطي وستُنفذ في الخلفية.",
  retention: "يحتفظ النظام تلقائيًا بآخر 3 نسخ ويحذف ملفات النسخ الأقدم مع إبقاء سجلها.",
  full: "نسخة كاملة", database: "قواعد البيانات", storage: "الملفات", queue: "بدء النسخ",
  size: "الحجم", startedAt: "وقت البدء", completedAt: "وقت الاكتمال", error: "رمز الخطأ",
  restore: "استعادة", restoreHistory: "سجل الاستعادة", backupId: "معرّف النسخة", restoreQueued: "تمت جدولة الاستعادة وستدخل المنصة وضع الصيانة تلقائيًا.",
  restoreWarning: "تحذير: ستُستبدل جميع قواعد البيانات والملفات بالحالة المحفوظة في هذه النسخة. ستتوقف الكتابة مؤقتًا وتُلغى التغييرات الأحدث.",
  confirmation: "عبارة التأكيد", confirmationHint: "اكتب العبارة حرفيًا: {{value}}", restoreNow: "تأكيد الاستعادة الكاملة"
});
Object.assign(en.pages.backups, {
  subtitle: "Create and download complete database and storage backups without terminal access",
  queued: "The backup job was queued and will run in the background.",
  retention: "The platform keeps the latest 3 backups automatically, removes older files, and preserves their audit records.",
  full: "Full backup", database: "Databases", storage: "Storage", queue: "Start backup",
  size: "Size", startedAt: "Started at", completedAt: "Completed at", error: "Error code",
  restore: "Restore", restoreHistory: "Restore history", backupId: "Backup ID", restoreQueued: "Restore was queued; the platform will enter maintenance mode automatically.",
  restoreWarning: "Warning: all databases and files will be replaced with the state in this backup. Writes pause temporarily and newer changes are discarded.",
  confirmation: "Confirmation phrase", confirmationHint: "Type this exactly: {{value}}", restoreNow: "Confirm full restore"
});
Object.assign(ar.pages.notifications, {
  subtitle: "إدارة التنبيهات داخل النظام وربط مزود WhatsApp المشفر",
  whatsappProvider: "مزود WhatsApp Cloud API", whatsappDescription: "تُحفظ رموز الوصول مشفرة ولا تظهر مجددًا في الواجهة.",
  configured: "تم الإعداد", verified: "آخر تحقق ناجح", phoneNumberId: "معرف رقم الهاتف",
  apiVersion: "إصدار Graph API", apiVersionHint: "أدخله كما يظهر في إعدادات Meta، مثل vXX.X.",
  accessToken: "رمز الوصول", accessTokenHint: "اتركه فارغًا عند التعديل للاحتفاظ بالرمز الحالي.",
  baseUrl: "عنوان Graph API", enableProvider: "تفعيل إرسال WhatsApp", templateMap: "ربط قوالب الأحداث (JSON)",
  templateMapHint: "مثال: {\"auth.otp\":\"aman_otp\",\"license.expiring\":\"aman_license_expiring\"}",
  saved: "تم حفظ إعدادات WhatsApp. أرسل اختبارًا لاعتماد الاتصال.", sendTest: "إرسال اختبار",
  testQueued: "أُضيفت رسالة الاختبار؛ ستظهر النتيجة في حالة المزود وسجل الإرسال.", deliveryLog: "سجل الإرسال",
  recipient: "المستلم", channel: "القناة", templateName: "اسم قالب Meta", languageCode: "لغة القالب",
  parameters: "قيم القالب", parametersHint: "قيمة واحدة في كل سطر وبنفس ترتيب متغيرات القالب."
});
Object.assign(en.pages.notifications, {
  subtitle: "Manage in-app notifications and the encrypted WhatsApp provider connection",
  whatsappProvider: "WhatsApp Cloud API provider", whatsappDescription: "Access tokens are encrypted and are never displayed again.",
  configured: "Configured", verified: "Last successful verification", phoneNumberId: "Phone number ID",
  apiVersion: "Graph API version", apiVersionHint: "Enter the version shown in Meta settings, such as vXX.X.",
  accessToken: "Access token", accessTokenHint: "Leave blank while editing to preserve the current token.",
  baseUrl: "Graph API URL", enableProvider: "Enable WhatsApp delivery", templateMap: "Event template map (JSON)",
  templateMapHint: "Example: {\"auth.otp\":\"aman_otp\",\"license.expiring\":\"aman_license_expiring\"}",
  saved: "WhatsApp settings were saved. Send a test to verify the connection.", sendTest: "Send test",
  testQueued: "The test was queued; its result will appear in provider status and the delivery log.", deliveryLog: "Delivery log",
  recipient: "Recipient", channel: "Channel", templateName: "Meta template name", languageCode: "Template language",
  parameters: "Template values", parametersHint: "One value per line, in the same order as the template variables."
});
Object.assign(ar.pages.notifications, { inApp: "تنبيهاتك داخل النظام" });
Object.assign(en.pages.notifications, { inApp: "Your in-app notifications" });
Object.assign(ar, { events: {
  "license.issued": "تم إصدار ترخيص جديد", "license.renewed": "تم تجديد الترخيص",
  "device.transfer.requested": "طلب نقل جهاز يحتاج المراجعة", "operation.created": "بدأت عملية مدفوعة",
  "operation.transitioned": "تغيرت حالة العملية", "voucher.redeemed": "تم استخدام كرت شحن",
  "backup.failed": "فشلت النسخة الاحتياطية", "license.expiring": "سينتهي الترخيص قريبًا",
  "wallet.low_balance": "رصيد المحفظة منخفض"
} });
Object.assign(en, { events: {
  "license.issued": "A new license was issued", "license.renewed": "A license was renewed",
  "device.transfer.requested": "A device transfer needs review", "operation.created": "A paid operation started",
  "operation.transitioned": "An operation status changed", "voucher.redeemed": "A credit voucher was redeemed",
  "backup.failed": "A backup failed", "license.expiring": "A license is expiring soon",
  "wallet.low_balance": "Wallet balance is low"
} });
Object.assign(ar.auth, {
  useOtp: "الدخول برمز WhatsApp", otpSubtitle: "دخول العملاء والموزعين برمز تحقق آمن",
  otpPhoneHint: "يتطلب مزود WhatsApp مفعّلًا ورقمًا مسجلًا بصيغة دولية.", sendOtp: "إرسال رمز التحقق",
  otpSent: "إذا كان الرقم مسجلًا فسيصلك رمز صالح لمدة 10 دقائق.", otpCode: "رمز التحقق",
  otpCodeHint: "أدخل الرمز المكوّن من 6 أرقام.", verifyOtp: "تحقق وسجّل الدخول", resendOtp: "إرسال رمز جديد",
  usePassword: "العودة إلى كلمة المرور"
});
Object.assign(en.auth, {
  useOtp: "Sign in with WhatsApp OTP", otpSubtitle: "Secure OTP sign-in for customers and resellers",
  otpPhoneHint: "Requires an enabled WhatsApp provider and a registered international phone number.", sendOtp: "Send verification code",
  otpSent: "If the number is registered, a code valid for 10 minutes will be delivered.", otpCode: "Verification code",
  otpCodeHint: "Enter the 6-digit code.", verifyOtp: "Verify and sign in", resendOtp: "Send a new code",
  usePassword: "Back to password"
});
Object.assign(ar.errors, {
  AUTH_OTP_INVALID: "رمز التحقق غير صحيح أو منتهي الصلاحية.",
  AUTH_OTP_UNAVAILABLE: "الدخول عبر WhatsApp غير متاح حتى يفعّل المدير المزود ويختبره.",
  AUTH_OTP_RATE_LIMITED: "تم طلب رموز كثيرة لهذا الرقم. حاول لاحقًا."
});
Object.assign(en.errors, {
  AUTH_OTP_INVALID: "The verification code is invalid or expired.",
  AUTH_OTP_UNAVAILABLE: "WhatsApp sign-in is unavailable until an administrator enables and verifies the provider.",
  AUTH_OTP_RATE_LIMITED: "Too many codes were requested for this number. Try again later."
});
Object.assign(ar.errors, {
  PLUGIN_WARNING_ACK_REQUIRED: "يجب تسجيل سبب تجاوز تحذيرات الإضافة قبل التثبيت.",
  BACKUP_NOT_READY: "لم تكتمل النسخة الاحتياطية المطلوبة بعد.",
  BACKUP_FAILED: "فشلت النسخة الاحتياطية المطلوبة قبل التثبيت.",
  RESTORE_CONFIRMATION_REQUIRED: "تتطلب الاستعادة تأكيدًا صريحًا."
});
Object.assign(en.errors, {
  PLUGIN_WARNING_ACK_REQUIRED: "A reason must be recorded before overriding plugin warnings.",
  BACKUP_NOT_READY: "The required backup is not ready yet.",
  BACKUP_FAILED: "The required pre-install backup failed.",
  RESTORE_CONFIRMATION_REQUIRED: "Restore requires explicit confirmation."
});
Object.assign(ar.pages.orders, {
  subtitle: "متابعة الطلبات والفواتير والإيصالات بلا ضريبة", invoiceNumber: "رقم الفاتورة",
  orderId: "رقم الطلب", displayPrice: "السعر المعروض", paidCredits: "المدفوع بالكريدت",
  invoice: "تنزيل الفاتورة", myInvoices: "فواتيري وإيصالاتي"
});
Object.assign(en.pages.orders, {
  subtitle: "Track orders, invoices, and tax-free receipts", invoiceNumber: "Invoice number",
  orderId: "Order ID", displayPrice: "Displayed price", paidCredits: "Paid credits",
  invoice: "Download invoice", myInvoices: "My invoices and receipts"
});

Object.assign(ar.common, { revoked: "ملغي", expired: "منتهي" });
Object.assign(en.common, { revoked: "Revoked", expired: "Expired" });
Object.assign(ar.pages.licenses, {
  settings: "الإعدادات",
  settingsTitle: "إعدادات الترخيص",
  suspend: "تعليق",
  resume: "استئناف",
  suspendTitle: "تعليق الترخيص",
  resumeTitle: "استئناف الترخيص",
  revokeTitle: "إلغاء الترخيص نهائيًا",
  revokeWarningTitle: "إجراء نهائي",
  revokeWarning: "سيُلغى هذا الترخيص نهائيًا ولن يمكن استئنافه. ستتوقف الأجهزة المرتبطة عند التحقق التالي.",
  reasonHint: "اكتب سببًا واضحًا من 3 أحرف على الأقل؛ سيُحفظ في سجل التدقيق.",
  selectedLicense: "الترخيص المحدد: {{id}}",
  maxDevices: "عدد الأجهزة",
  maxDevicesHint: "أدخل 0 لمنع تفعيل أجهزة جديدة على هذا الترخيص.",
  expiresAt: "تاريخ الانتهاء",
  planEntitlements: "استحقاقات الباقة",
  planEntitlementsHint: "للمراجعة فقط؛ تأتي هذه القيم من الباقة المحددة.",
  entitlementOverrides: "تخصيص استحقاقات الترخيص (JSON)",
  entitlementOverridesHint: "تتغلب هذه القيم على استحقاقات الباقة لهذا الترخيص فقط. استخدم {} للعودة بالكامل إلى قيم الباقة.",
  usePlanDefaults: "استخدام استحقاقات الباقة",
  maxDevicesInvalid: "يجب أن يكون عدد الأجهزة رقمًا صحيحًا لا يقل عن صفر.",
  entitlementsJsonInvalid: "صيغة JSON غير صحيحة. راجع الأقواس والفواصل والقيم.",
  entitlementsObjectRequired: "يجب أن تكون الاستحقاقات كائن JSON، مثل {\"users.max\": 250} أو {}.",
});
Object.assign(en.pages.licenses, {
  settings: "Settings",
  settingsTitle: "License settings",
  suspend: "Suspend",
  resume: "Resume",
  suspendTitle: "Suspend license",
  resumeTitle: "Resume license",
  revokeTitle: "Permanently revoke license",
  revokeWarningTitle: "Permanent action",
  revokeWarning: "This license will be permanently revoked and cannot be resumed. Connected devices will be blocked on their next validation.",
  reasonHint: "Enter a clear reason of at least 3 characters; it will be kept in the audit log.",
  selectedLicense: "Selected license: {{id}}",
  maxDevices: "Devices",
  maxDevicesHint: "Enter 0 to prevent new device activations for this license.",
  expiresAt: "Expires at",
  planEntitlements: "Plan entitlements",
  planEntitlementsHint: "Read-only reference values from the selected plan.",
  entitlementOverrides: "License entitlement overrides (JSON)",
  entitlementOverridesHint: "These values override the plan for this license only. Use {} to return fully to the plan defaults.",
  usePlanDefaults: "Use plan entitlements",
  maxDevicesInvalid: "The device limit must be a whole number greater than or equal to zero.",
  entitlementsJsonInvalid: "The JSON is invalid. Check its braces, commas, and values.",
  entitlementsObjectRequired: "Entitlements must be a JSON object, such as {\"users.max\": 250} or {}.",
});

Object.assign(ar.nav, { appliances: "الأجهزة المُدارة" });
Object.assign(en.nav, { appliances: "Managed appliances" });
Object.assign(ar.pages, { appliances: {
  title: "أجهزة RADIUS المُدارة",
  subtitle: "اعتماد أجهزة التثبيت الصفري ومراقبتها وإرسال عمليات إدارة محددة ومدققة",
  displayName: "اسم النظام", hostname: "اسم المضيف", claimCode: "رمز المطالبة", ipAddress: "عنوان IP", lastSeen: "آخر اتصال",
  approve: "اعتماد وربط", reject: "رفض", approveTitle: "اعتماد الجهاز وربطه بترخيص",
  approveWarning: "بعد الاعتماد سيستلم الجهاز الترخيص والإعدادات دون كشف مفتاح الترخيص.",
  diagnostics: "جمع التشخيص", restartRadius: "إعادة تشغيل RADIUS", update: "تحديث", reboot: "إعادة تشغيل الجهاز",
  commandTitle: "إرسال أمر إدارة", commandSummary: "سيتم إرسال «{{command}}» إلى {{device}} عبر القناة الموقعة.",
  requestQueued: "تم قبول الطلب وسيُنفّذ عند اتصال الجهاز القادم."
} });
Object.assign(en.pages, { appliances: {
  title: "Managed RADIUS appliances",
  subtitle: "Approve zero-touch installations, monitor them, and send constrained audited operations",
  displayName: "System name", hostname: "Hostname", claimCode: "Claim code", ipAddress: "IP address", lastSeen: "Last seen",
  approve: "Approve and bind", reject: "Reject", approveTitle: "Approve and bind appliance",
  approveWarning: "After approval the appliance receives its license and configuration without exposing the license key.",
  diagnostics: "Collect diagnostics", restartRadius: "Restart RADIUS", update: "Update", reboot: "Reboot appliance",
  commandTitle: "Send management command", commandSummary: "“{{command}}” will be sent to {{device}} over the signed channel.",
  requestQueued: "The request was accepted and will run on the appliance's next connection."
} });

Object.assign((ar.pages as unknown as Record<string, Record<string, string>>)["appliances"]!, {
  reEnroll: "إعادة تسجيل المفتاح",
  reEnrollTitle: "إعادة تسجيل الجهاز بأمان",
  reEnrollWarning: "سيتم تعطيل المفتاح السابق وفك الربط مؤقتاً. لن يُقبل المفتاح الجديد إلا لأنه ظهر في طلب موقّع حديث، وسيبقى الجهاز قيد الانتظار حتى تعيد ربطه بالترخيص الأصلي.",
  newKeyHash: "بصمة المفتاح الجديد",
  candidateIp: "عنوان IP للمرشح",
  candidateLastSeen: "آخر محاولة للمرشح",
  confirmAppliance: "اكتب معرّف الجهاز للتأكيد: {{id}}",
});
Object.assign((en.pages as unknown as Record<string, Record<string, string>>)["appliances"]!, {
  reEnroll: "Re-enroll key",
  reEnrollTitle: "Securely re-enroll appliance",
  reEnrollWarning: "The previous key will be disabled and the binding temporarily released. The new key is eligible only because it appeared in a recent signed request; the appliance remains Pending until it is rebound to its original license.",
  newKeyHash: "New key fingerprint",
  candidateIp: "Candidate IP address",
  candidateLastSeen: "Candidate last attempt",
  confirmAppliance: "Type the appliance ID to confirm: {{id}}",
});

Object.assign((ar.pages as unknown as Record<string, Record<string, string>>)["appliances"]!, {
  deviceId: "معرّف الجهاز",
  deletePermanently: "حذف نهائي",
  deleteTitle: "حذف الجهاز المُدار نهائياً",
  deleteWarning: "سيُحذف الجهاز من قائمة الأجهزة المُدارة نهائياً مع الاحتفاظ بالترخيص وسجل الجهاز وأوامر الإدارة في الأرشيف. يُرفض الحذف فقط إذا كان الجهاز أو الترخيص نشطاً.",
  deleted: "تم حذف الجهاز المُدار نهائياً مع الاحتفاظ بسجل التدقيق.",
});
Object.assign((en.pages as unknown as Record<string, Record<string, string>>)["appliances"]!, {
  deviceId: "Device ID",
  deletePermanently: "Delete permanently",
  deleteTitle: "Permanently delete managed appliance",
  deleteWarning: "This permanently removes the appliance from Managed appliances while retaining its license, device history, and command audit history. Deletion is refused only while the device or license is active.",
  deleted: "The managed appliance was permanently deleted and its audit record was retained.",
});

Object.assign(ar.auth, {
  attemptsRemaining: "تنبيه: تبقّت {{count}} محاولة قبل حظر الحساب مؤقتًا.",
  lockedRetry: "تم حظر الحساب مؤقتًا. حاول مجددًا بعد {{minutes}} دقيقة كحد أقصى.",
});
Object.assign(en.auth, {
  attemptsRemaining: "Warning: {{count}} login attempt(s) remain before the account is temporarily locked.",
  lockedRetry: "The account is temporarily locked. Try again in no more than {{minutes}} minute(s).",
});

const saved = localStorage.getItem("aman.locale");
const language = saved === "en" ? "en" : "ar";
void i18n.use(initReactI18next).init({ resources: { ar: { translation: ar }, en: { translation: en } }, lng: language, fallbackLng: "ar", interpolation: { escapeValue: false }, returnNull: false });

export function applyDocumentLocale(locale: string): void {
  const normalized = locale === "en" ? "en" : "ar";
  document.documentElement.lang = normalized;
  document.documentElement.dir = normalized === "ar" ? "rtl" : "ltr";
  localStorage.setItem("aman.locale", normalized);
}

applyDocumentLocale(language);
export default i18n;
